import { FiAlertCircle, FiCheckCircle, FiInfo } from "react-icons/fi";

export function Button({
  variant = "primary",
  loading = false,
  disabled = false,
  type = "button",
  children,
  className = "",
  ...rest
}) {
  return (
    <button
      type={type}
      className={`ax-btn ax-btn--${variant} ${className}`.trim()}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="ax-spin" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}

const ALERT_ICONS = { info: FiInfo, success: FiCheckCircle, error: FiAlertCircle };

export function Alert({ tone = "info", children, ...rest }) {
  const Icon = ALERT_ICONS[tone] || FiInfo;
  return (
    <div
      className={`ax-alert ax-alert--${tone}`}
      role={tone === "error" ? "alert" : "status"}
      {...rest}
    >
      <Icon aria-hidden="true" size={18} />
      <div>{children}</div>
    </div>
  );
}

/** "Step 2 of 4 · Contact" with a segmented bar. `current` is zero-based. */
export function StepProgress({ steps, current }) {
  return (
    <div
      className="ax-progress"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={steps.length}
      aria-valuenow={current + 1}
      aria-valuetext={`Step ${current + 1} of ${steps.length}: ${steps[current]}`}
    >
      <div className="ax-progress-label">
        <span>
          <strong>
            Step {current + 1} of {steps.length}
          </strong>
        </span>
        <span>{steps[current]}</span>
      </div>
      <div className="ax-bars" aria-hidden="true">
        {steps.map((label, i) => (
          <span key={label} className={i <= current ? "is-done" : ""} />
        ))}
      </div>
    </div>
  );
}

/** Back / Continue row. Sticks to the bottom of the card on phones. */
export function ActionBar({ sticky = false, total, children }) {
  return (
    <div className={`ax-actions${sticky ? " ax-actions--sticky" : ""}`}>
      {total ? <div className="ax-actions-total">{total}</div> : null}
      {children}
    </div>
  );
}
